import moment from 'moment';
import * as echarts from 'echarts';
import L from 'leaflet';

export function loadScript(url) {
  return new Promise((resolve, reject) => {
    //console.log('load script1', url);
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.onload = script.onreadystatechange = function() {
      if (
        !this.readyState || // 现代浏览器没有 readyState
        this.readyState == 'loaded' ||
        this.readyState == 'complete' // 这是IE的判断语句
      ) {
        resolve();
      }
    };
    script.onerror = () => reject();
    document.head.appendChild(script); //塞进页面
  });
}

/**
 * 样式文件不关心顺序
 */
export function loadStyle(url) {
  //console.log('load style', url);
  const link = document.createElement('link');
  link.href = url;
  document.head.appendChild(link);
}

function parseQuery(str) {
  if (!str) return {};
  const index = str.indexOf('?');
  if (index === -1) return {};
  const query = str.slice(index + 1);
  return query.split('&').reduce((acc, keyVal) => {
    if (!keyVal) return acc;
    const arr = keyVal.split('=');
    acc[arr[0]] = arr[1];
    return acc;
  }, {});
}

export function serializer(obj) {
  let str = Object.keys(obj).reduce((acc, c) => {
    acc = acc + '&' + [c] + '=' + obj[c];
    return acc;
  }, '');

  return str.slice(1);
}

export function safeGetStorage(key) {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    return '';
  }
}

export function safeSetStorage(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch (e) {
    //console.log('e', e);
  }
}

export function safeGetSessionStorage(key) {
  try {
    return sessionStorage.getItem(key);
  } catch (e) {
    return '';
  }
}

export function safeSetSessionStorage(key, value) {
  try {
    sessionStorage.setItem(key, value);
  } catch (e) {
    //console.log('e', e);
  }
}

export function getToken() {
  return safeGetStorage('apiKey');
}

export function setToken(token) {
  return safeSetStorage('apiKey', token);
}

export function getParam() {
  return {
    ...parseQuery(location.search),
    ...parseQuery(location.hash)
  };
}

export function safeParse(str) {
  try {
    return JSON.parse(str);
  } catch (e) {
    console.warn('json parse error', e);
    return null;
  }
}

export function safeStringify(obj) {
  try {
    return JSON.stringify(obj);
  } catch (e) {
    console.warn('json stringify error', e);
    return '';
  }
}

export function getIntergrityInterval(arr, refArr = [], index, extra) {
  let newArr = [];
  let currentStartIndex = null;
  let currentEndIndex = null;
  let prev = 0;
  let i = 0;

  let length = arr.length;

  while (i < length) {
    const val = arr[i];

    if (val === 0) {
      if (prev === 0) {
        i++;
        prev = val;
        continue;
      }

      if (prev === 1) {
        currentEndIndex = refArr[i];
      }
    }

    if (val === 1) {
      if (prev === 0) {
        currentStartIndex = refArr[i];
      }

      if (prev === 1) {
        if (i !== length - 1) {
          i++;
          prev = val;
          continue;
        } else {
          currentEndIndex = refArr[i];
        }
        // i++;
      }
    }

    if (currentStartIndex !== null && currentEndIndex !== null) {
      newArr.push({
        value: [
          index,
          moment(currentStartIndex).valueOf(),
          moment(currentEndIndex).valueOf()
        ],
        itemStyle: extra
      });
      currentStartIndex = null;
      currentEndIndex = null;
    }
    i++;
    prev = val;
  }

  return newArr;
}

export async function getDataURLByEchartOptions(options, divOption = {}) {
  const { width = '500px', height = '300px', notMerge = false } = divOption;
  const div = document.createElement('div');
  div.style.width = width;
  div.style.height = height;
  const myChart = echarts.init(div);

  myChart.setOption(options, notMerge);

  return new Promise(resolve => {
    setTimeout(() => {
      resolve(
        myChart.getDataURL({
          pixelRatio: 2
        })
      );
    }, 2000);
  });
}

export function hasPermission(/** user, code */) {
  // todo: 权限功能后台还没有，先默认返回true
  return true;
  // const codes = user?.functionMenu || [];
  // return Boolean(codes.find(codeItem => codeItem.functionCode === code));
}

export function isInteger(obj) {
  return obj % 1 === 0;
}

export function isObject(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}

export function findDeepId(data) {
  if (Array.isArray(data)) {
    const firstItem = data[0];
    return findDeepId(firstItem);
  } else {
    if (isObject(data)) {
      return data.id;
    } else {
      return '';
    }
  }
}

export function downLoadFile(url) {
  const iframe = document.createElement('iframe');
  iframe.src = url;
  document.body.append(iframe);

  iframe.style.display = 'none';

  //setTimeout(() => {
  //document.body.removeChild(iframe);
  //}, 2000);
}

export class Pop {
  constructor() {
    this.pop = L.popup();
  }

  async creatContent({ data, map }, template, callback) {
    const { lat, lng } = data;

    const res = await template(data);

    this.pop
      .setLatLng({ lat: lat, lng: lng })
      .setContent(res.root)
      .openOn(map);

    callback && callback(res.data, data);
  }

  clear() {
    this.pop.remove();
  }
}
